import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

PureButton.propTypes = {
    as: PropTypes.elementType,
    className: PropTypes.string,
    startIcon: PropTypes.node,
    endIcon: PropTypes.node,
    styles: PropTypes.shape({
        button: PropTypes.string,
        startIcon: PropTypes.string,
        endIcon: PropTypes.string,
    }),
};

PureButton.defaultProps = {
    as: 'button',
    styles: {},
};

export default function PureButton({ as: Component, className, startIcon, endIcon, children, styles, ...rest }) {
    return (
        <Component className={cn(styles.button, className)} {...getProps(Component, rest)}>
            {startIcon && <span className={styles.startIcon}>{startIcon}</span>}
            {children}
            {endIcon && <span className={styles.endIcon}>{endIcon}</span>}
        </Component>
    );
}

export function getProps(el, props) {
    const { type, disabled, ...rest } = props;
    const out = { ...rest };

    if (el === 'button') {
        out.type = type || 'button';
        out.disabled = disabled;
    } else {
        out.role = 'button';
        out.tabIndex = '0';
        if (disabled) out['aria-disabled'] = true;
    }

    return out;
}
